import global from '../global'

export default ({
	addToCart (cart) {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/cart/addtocart',
				data: JSON.stringify(cart),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	},
	emptyCart () {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/cart/empty',
				data: JSON.stringify({'cart_id': this.$root.cartId}),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	},
	getCart (cartId) {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/cart/' + cartId + '/show',
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	},
	placeOrder (obj) {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/order/place',
				data: JSON.stringify(obj),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	}
})



// WEBPACK FOOTER //
// ./src/controllers/Orders.js